<template>
  <div class="v2-theme v2-layout">
    <!--
      KP-3336: cache the Orders and Shipments list views (by component name) so
      their filters / search / pagination are retained when the user opens an
      order/shipment detail and navigates back. Every other v2 route is not in
      the include list, so it mounts/unmounts normally. The list views refresh
      their data on re-entry via an `activated()` hook (filters are retained).
    -->
    <keep-alive :include="['V2OrderList', 'V2ShipmentList']">
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: 'LayoutV2',
}
</script>

<style lang="scss">
@import '~flatpickr/dist/flatpickr.css';
@import '~flatpickr/dist/plugins/monthSelect/style.css';
@import '@/assets/scss/v2/v2.scss';

.v2-layout {
  position: relative;
  min-height: 100vh;
  // Transparent so the ambient mesh below shows through; mesh provides the
  // substrate that v2-glass-* utilities blur against (Option A — see
  // docs/glassmorphism-migration-plan.md). backdrop-filter does not cross
  // iframe boundaries, so we cannot rely on the parent PLG gradient.
  background: transparent;
  color: var(--v2-foreground);
  font-family: var(--v2-font-sans);
  padding: var(--v2-space-6);
  overflow: visible;
}

// Ambient blob rules removed — see template comment for rationale.
// Body stays transparent (rule below) so PLG's ambient mesh shows
// through the iframe directly without any b2b-side tint stacking.

// Transparent body on v2 routes — lets the parent (PLG iframe wrapper)
// background show through any gap, and stops the b2b iframe from
// painting its own opaque base. The ambient blobs are rendered as DOM
// children of `.v2-layout`, not on body. Scoped to v2 routes only
// (Bootstrap's `$body-bg` covers non-v2 fallback routes).
body:has(.v2-layout) {
  background: transparent;
}

// Ensure #app does not create a secondary scrollbar when v2-layout content grows
#app:has(.v2-layout) {
  height: auto;
  min-height: 100%;
}
</style>
